import { LOADER_DELAY, POST_LOADER_DELAY } from '@/constants';
import { MESSAGES } from './constants';

function emailConfirm(this: IView) {
  const self = this;
  this.$store.commit('dialog/CREATE', {
    title: 'Code Sent',
    compact: true,
    component: {
      data: () => ({
        code: '',
        confirming: false,
        email: this.email,
        error: '',
      }),
      methods: {
        validate() {
          // prevent checking multiple times
          if (this.confirming === true) {
            return;
          }

          this.confirming = true;
          this.error = '';
          setTimeout(() => {
            self.$store
              .dispatch('auth/login', {
                code: {
                  email: this.email,
                  value: this.code,
                },
              })
              .then(
                () => {
                  this.$emit('close');
                  this.$router.push(self.redirectPath);
                },
                (e: any) => {
                  const message = MESSAGES[e.code] || MESSAGES.UNKNOWN_ERROR;
                  this.error = this.$formatMessage(message);
                  this.confirming = false;

                  // focus on code field
                  this.$nextTick(() => this.$refs.code.focus());
                },
              );
          }, 500);
        },
      },
      template: `
        <div>
          ${this.$formatMessage(MESSAGES.SIGNIN_CONFIRM)}
          <input
            v-model="code"
            ref="code"
            type="tel"
            class="login-code"
            pattern="[0-9]*"
            placeholder="00000"
            novalidate
            :disabled="confirming"
            @keydown="error = ''"
            @keyup.enter="validate"
          />
          <div class="login-code-messages">
            <transition name="transition fade-down">
              <p v-if="confirming">
                Confirming code for <strong>${this.email}</strong>
              </p>
            </transition>
            <transition name="transition fade-down">
              <div v-if="error"
                v-html="error"
                class="error">
              </div>
            </transition>
          </div>
        </div>
      `,
    } as IView,
    delay: LOADER_DELAY,
    buttons: [
      {
        text: 'Login with code',
        click: (message: any) => message.component[0].validate(),
      },
      {
        text: 'Close',
        click: (message: any) => message.close(),
      },
    ],
  });
}

function signupError(
  this: IView,
  error: any,
) {
  console.error(error);

  this.$store.commit('dialog/CREATE', {
    title: 'Error :(',
    content: MESSAGES[error.code] || MESSAGES.UNKNOWN_ERROR,
    delay: POST_LOADER_DELAY,
    compact: true,
    buttons: [
      {
        text: 'Close',
        click: (dialog: any) => dialog.close(),
      },
    ],
  });
}

export default {
  emailConfirm,
  signupError,
} as any;
